export default Object.freeze({
  ENTITY: 'ENTITY',
  CUSTOM: 'CUSTOM',
  KEY_ENTITY: 'entities',
  KEY_CUSTOM: 'customFields',
})
